import { render, staticRenderFns } from "./FormularioConsulta.vue?vue&type=template&id=3b7aa5a4"
import script from "./FormularioConsulta.vue?vue&type=script&lang=js"
export * from "./FormularioConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports